import './overview.scss';
// import '../popup.scss';
import init_listing from 'components/listing/Listing';
// import Popup_Content from '../popup';

function init() {
    const listing = init_listing('#team_listing_items', {
        query_all: 'teams/ajax_query_all',
        // search_input: '#listing_filter_search',
        filters: [
            {
                el: '#listing_filter_category',
                type: 'dropdown',
                key: 'categories',
            },
        ],
        // sort: '#listing_sort',
        load_more: true,
        load_more_auto: true,
        transition_duration: 300,
        items_data: listings_data.items,
        post_count: parseInt(listings_data.post_count),
        found_posts: parseInt(listings_data.found_posts),
        query_args: listings_data.query_args,
    });

    // init_popup();
}

// function init_popup() {
//     const popup = new Popup_Content('.popup_content');
//     const container = document.getElementById('team_listing_items');
//     if (!container) return;

//     container.addEventListener('click', (e) => {
//         const item = e.target.closest('.item_team');
//         if (!item) return;
//         e.preventDefault();
//         const item_data = JSON.parse(item.dataset.popup);
//         popup.open(item_data);
//     });
// }

init();